export default function CaretIcon() {
    return (
        <svg width="24" height="10" viewBox="0 0 24 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.2931 0C32.7602 0 -8.76159 0 1.70747 0C5.5668 0 9.1862 10 12.0003 10C14.8144 10 18.475 0 22.2931 0Z" fill="white" />
        </svg>
    );
}
